<template>
    <div>
        <UiCardListHeader :title="lang('congresses::check-in.title')" />

        <div>
            <UiCardEmpty v-if="congresses.length === 0">
                {{ lang('congresses::check-in.no_congresses') }}
            </UiCardEmpty>

            <Button v-else type="button" color="default" class="w-full quick-action" @click="openCheckIn">
                <Icon icon="phosphor/regular/user-check" class="w-4 h-4 mr-2" />
                {{ lang('congresses::check-in.title') }}
                <KbdShortcut keys="Alt+C" size="sm" class="ml-2" />
            </Button>
        </div>

    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import type { Ref } from 'vue';
import { router } from '@inertiajs/vue3';
import KbdShortcut from '@src/Common/Components/KbdShortcut.vue';
import { onKeyStroke } from '@vueuse/core';

interface CongressOption {
    id: number;
    title: string;
    start_date: string | null;
    end_date: string | null;
}

interface WidgetData {
    congresses?: CongressOption[];
}

const props = defineProps<{ slug?: string; settings?: object; data?: WidgetData }>();

const congresses: Ref<CongressOption[]> = ref(props.data?.congresses ?? []);

function openCheckIn(): void {
    router.visit(route('congresses.admin.check-in'));
}

onKeyStroke(true, (e) => {
    if (e.code !== 'KeyC' || !e.altKey) return;
    if (congresses.value.length === 0) return;
    e.preventDefault();
    openCheckIn();
});
</script>
